import React, { useState, useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import Header from './header/Header';
import Sidebar from './sidebar/Sidebar';
import DeviceWarning from '../../components/common/deviceWarning/DeviceWarning';
import useRetentionZen from '../../hooks/useRetentionZen';

export default function Layout() {
    // Initialize RetentionZen widget hook
    useRetentionZen();
    const [showWarning, setShowWarning] = useState(false);
    const [isSmallDevice, setIsSmallDevice] = useState(false);

    useEffect(() => {
        // Check if device width is less than 1025px
        const checkDeviceWidth = () => {
            const width = window.innerWidth;
            setIsSmallDevice(width < 1280);
        };

        // Check on mount
        checkDeviceWidth();

        // Check on resize
        window.addEventListener('resize', checkDeviceWidth);

        return () => {
            window.removeEventListener('resize', checkDeviceWidth);
        };
    }, []);

    useEffect(() => {
        // Check if user has dismissed the warning in this session
        const hasAcknowledged = sessionStorage.getItem('deviceWarningAcknowledged');

        if (isSmallDevice && !hasAcknowledged) {
            setShowWarning(true);
        } else {
            setShowWarning(false);
        }
    }, [isSmallDevice]);

    const handleDismiss = () => {
        sessionStorage.setItem('deviceWarningAcknowledged', 'true');
        setShowWarning(false);
    };

    // If warning should be shown, only render the warning modal
    if (showWarning) {
        return <DeviceWarning onDismiss={handleDismiss} />;
    }

    // Otherwise, render the normal layout with all components
    return (
        <>
            <Sidebar />
            <Header />
            <Outlet />
        </>
    );
}
